import classNames from 'classnames';
import React from 'react';

import './Wrapper.scss';
import { WrapperStatusMsg } from './WrapperStatusMsg';

export interface WrapperProps {
  label?: string;
  successMsg?: string;
  error?: string;
  infoMsg?: string;
  htmlFor?: string;
  withoutStatus?: boolean;
  helper?: React.ReactNode;
  className: string;
  children?: any;
}

export function Wrapper({
  label,
  htmlFor,
  successMsg,
  error,
  className,
  infoMsg,
  withoutStatus,
  helper,
  ...props
}: WrapperProps): React.ReactElement {
  const wrapperClasses = classNames('wrapper', {
    [`${className}`]: className,
  });

  const fieldClasses = classNames('field', {
    [`${className}__field`]: className,
  });

  return (
    <div className={wrapperClasses}>
      <div className={fieldClasses}>
        {props.children}
        {label && (
          <label className={'label'} htmlFor={htmlFor}>
            {label}
          </label>
        )}
      </div>
      {!withoutStatus && <WrapperStatusMsg error={error} successMsg={successMsg} infoMsg={infoMsg} className={className} />}
      {!!helper && helper}
    </div>
  );
}
